<template>
    <div class="part">
        <div class="center-text">
            <p class="part-title">{{ $t("Choose your Destination") }}</p>
            <div class="areas">
                <!-- <google-places-autocomplete /> -->
                <basic-select
                    :options="options"
                    :placeholder="$t('From')"
                    @raw="handleFromCountrySelect($event)"
                    :counterError="false"
                    ref="country"
                    :showFlag="true"
                ></basic-select>
                <br />
                <br />
                <basic-select
                    :options="options"
                    :placeholder="$t('To')"
                    @raw="handleToCountrySelect($event)"
                    :counterError="false"
                    ref="country"
                    :showFlag="true"
                ></basic-select>
            </div>
            <p style="margin-top: 35px">
                {{ $t("Add the estimated weight") }}
            </p>
            <div class="weight-area">
                <div class="level">
                    <div class="level-item">
                        <span class="dim">{{ $t("kg") }}</span>
                        <span
                            class="operator"
                            @click="
                                estimateWeight != 0 ? estimateWeight-- : null
                            "
                            >-</span
                        >
                        <span class="weight-number">
                            <input
                                v-model.lazy="estimateWeight"
                                v-debounce="1000"
                            />
                        </span>
                        <span class="operator" @click="estimateWeight++"
                            >+</span
                        >
                    </div>
                </div>
            </div>
            <div v-if="loading" class="mb-5">
                <Loading />
                <span>{{ $t("Calculating...") }}</span>
            </div>
            <div v-else class="price">{{ totalProcessPrice }}</div>
            <span class="error" v-if="showErrorMsg">
                {{ $t(showErrorMsg) }}
                <br />
            </span>
            <br />
            <router-link to="/send-shipment" class="button is-primary">
                {{ $t("Start your shipping process") }}
            </router-link>
        </div>
    </div>
</template>

<script>
import BasicSelect from "@/components/BasicSelect.vue";
import Loading from "@/components/Loading";
import debounce from "v-debounce";
// import { GooglePlacesAutocomplete } from "vue-better-google-places-autocomplete";

export default {
    name: "International",
    components: {
        "basic-select": BasicSelect,
        Loading,
        // GooglePlacesAutocomplete,
    },
    data() {
        return {
            place: "",
            fromCountry: 0,
            toCountry: 0,
            estimateWeight: 0,
            totalProcessPrice: 0,
            loading: false,
            showErrorMsg: null,
        };
    },
    watch: {
        estimateWeight: {
            handler(val) {
                if (val) {
                    if (!this.fromCountry || !this.toCountry) {
                        this.$buefy.toast.open({
                            message: this.$t(
                                "Please choose the destinations correctly"
                            ),
                            type: "is-primary",
                        });
                        return (this.estimateWeight = 0);
                    }
                    this.internationalRateReq();
                }
            },
        },
        fromCountry: {
            handler(val) {
                this.estimateWeight = 0;
            },
        },
        toCountry: {
            handler(val) {
                this.estimateWeight = 0;
            },
        },
    },
    computed: {
        options() {
            return this.$store.state.countries;
        },
    },
    methods: {
        internationalRateReq() {
            this.loading = true;
            this.showErrorMsg = null;
            this.$store
                .dispatch("internationalRateReq", {
                    origin: this.fromCountry,
                    destination: this.toCountry,
                    weight: this.estimateWeight,
                })
                .then((res) => {
                    this.totalProcessPrice = res.data.data;
                })
                .catch((e) => {
                    this.showErrorMsg = e.data.response.data.message;
                })
                .finally(() => (this.loading = false));
        },
        setAction() {
            this.$buefy.toast.open({
                message: this.$t("Coming Soon!"),
                type: "is-primary",
            });
        },
        handleFromCountrySelect(e) {
            this.fromCountry = e;
        },
        handleToCountrySelect(e) {
            this.toCountry = e;
        },
    },
    directives: {
        debounce,
    },
};
</script>

<style lang="scss" scoped>
.error {
    color: red;
}
.part {
    width: 100%;
    height: 100%;
    text-align: center;

    .part-title {
        text-align: left;

        &:lang(ar) {
            text-align: right;
        }
    }

    p {
        font-weight: bold;
        font-size: 1.2rem;
    }

    .center-text {
        text-align: center;
    }

    .areas {
        background-color: #f5f5f5;
        padding: 15px 0;
        margin: 20px 0;

        ::v-deep {
            input,
            .select select {
                background-color: transparent;
                border-color: transparent !important;
                outline: none !important;
            }

            .basic-select {
                display: inline-block;
                width: 80%;
                position: relative;
                vertical-align: top;

                .select-head {
                    span {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }

    .weight-area {
        position: relative;
        background-color: #f5f5f5;
        padding: 10px;
        margin: 15px 0 30px 0;
        display: inline-block;
        width: 220px;

        span {
            display: inline-block;
        }

        .dim {
            position: absolute;
            bottom: -1px;
            left: 46%;
        }

        .weight-number {
            min-width: 100px;
            font-size: 2rem;

            input {
                background: none;
                text-align: center;
                font-size: inherit;
                width: 100px;
                outline: 0;
            }
        }

        .operator {
            font-size: 1.6rem;
            font-weight: bold;
            cursor: pointer;
        }
    }

    .price {
        font-size: 2.2rem;
        color: black;
        position: relative;
        margin: 20px 0 50px 0;

        &::before {
            content: "SAR";
            position: absolute;
            display: inline-block;
            right: calc(50% - 50px);
            top: 100%;
            font-size: 0.85rem;
            color: #8c8c8c;
        }
    }
}

.button {
    border-radius: 3px !important;
    width: 250px;
}
</style>
